import { Factory } from '../Factory';
import { Service } from '../Service';

export class RelativitySettingsService extends Service<any> {
  constructor(resource: any, rootScope: IRootScope, private configService, resourceWrapperService, private httpService) {
    super({resource, rootScope, resourceWrapperService});

    let relativitySettingsResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/relativity/settings/:id`,
      {id: "@id", projectId: "@projectId"},
      {update: {method: "PUT"}});

    this.itemResource = this.resourceWrapperService.WrapActions(relativitySettingsResource);
  }

  public GetFields(projectId) {
    let url = `${this.configService.getServerBaseUrl()}/project/${projectId}/relativity/settings/iio/fields`;

    return this.httpService.$http({
      method: "GET",
      url: url
    });
  }
}

frontendApp.factory("RelativitySettingsService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "HttpService", Factory.Create(RelativitySettingsService)]);
